<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/45PZOY/tc-custom/9781429915632.jpg?1731554435485" alt="This image is the cover for the book Orphans of Chaos, The Chronicles of Chaos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Orphans of Chaos, The Chronicles of Chaos
      </h1>
      <p class="bookDescription body article font2">
        <b>“Those who like sophisticated fantasy with a mild erotic charge will be most rewarded” by this “intriguing” fantasy about teens held hostage by Greek gods (<i>Publishers Weekly</i>).</b><br/><br/>John C. Wright burst onto the SF scene with the Golden Age trilogy. His next project was the ambitious fantasy sequence, The Last Guardians of Everness.<br/><br/>Wright’s new fantasy is a tale about five orphans raised in a strict British boarding school who begin to discover that they may not be human beings. The students at the school do not age, while the world around them does.<br/><br/>The children begin to make sinister discoveries about themselves. Amelia is apparently a fourth-dimensional being; Victor is a synthetic man who can control the molecular arrangement of matter around him; Vanity can find secret passageways through solid walls where none had previously been; Colin is a psychic; Quentin is a warlock. Each power comes from a different paradigm or view of the inexplicable universe: and they should not be able to co-exist under the same laws of nature. Why is it that they can?<br/><br/>The orphans have been kidnapped from their true parents, robbed of their powers, and raised in ignorance by super-beings no more human than they are: pagan gods or fairy-queens, Cyclopes, sea-monsters, witches, or things even stranger than this. The children must experiment with, and learn to control, their strange abilities in order to escape their captors.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John C. Wright
      </h2>
      
      <p class="authorDescription body article"><P>JOHN C. WRIGHT, an attorney turned SF and fantasy writer, has published short fiction in <I>Asimovs SF</I> and elsewhere. <I>Orphans of Chaos</I> is his second fantasy novel, after <I>The Last Guardian of Everness </I>and the SF trilogy, The Golden Age.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a7f2e31